<template>
	<div>
		<h1 class="section-title">Mi Expediente</h1>

		<!-- Caso 1 -->
		<div
			class="case-card mb-3"
			:class="{ expanded: expandedCase === 1 }"
			@click="toggleCase(1)"
		>
			<div class="case-card-header d-flex align-items-center justify-content-between">
				<div>
					<h3 class="case-title mb-1">Caso Activo - Consulta Laboral</h3>
					<p class="case-desc mb-0">Iniciado el 20 de Enero 2025</p>
				</div>
				<div class="d-flex align-items-center">
					<span class="status-badge status-review">En revisión</span>
					<i
						class="fa-regular ml-3 case-chevron"
						:class="expandedCase === 1 ? 'fa-chevron-down' : 'fa-chevron-right'"
					></i>
				</div>
			</div>

			<div v-if="expandedCase === 1" class="case-card-body" @click.stop>
				<!-- Info del caso -->
				<div class="case-block case-block-primary mb-4">
					<h4 class="case-block-title text-primary">
						<i class="fa-regular fa-user mr-2"></i>
						Información del Caso
					</h4>
					<div class="row">
						<div class="col-md-6 mb-3 mb-md-0">
							<h5 class="case-block-subtitle">Tu Información</h5>
							<div class="info-panel mb-3">
								<div class="info-field">
									<span class="info-label">Tipo de Entidad</span>
									<span class="info-value">{{ expedienteData.tipoEntidad }}</span>
								</div>
								<div class="info-field">
									<span class="info-label">Nombre Completo</span>
									<span class="info-value">{{ expedienteData.nombreCompleto }}</span>
								</div>
								<div class="info-field">
									<span class="info-label">RFC</span>
									<span class="info-value">{{ expedienteData.rfc }}</span>
								</div>
							</div>
							<div class="info-panel">
								<span class="info-label d-block mb-2">Comentarios</span>
								<p class="mb-0 small">{{ expedienteData.comentarios }}</p>
							</div>
						</div>
						<div class="col-md-6">
							<h5 class="case-block-subtitle">Información de la Contraparte</h5>
							<div class="info-panel">
								<div class="info-field">
									<span class="info-label">Tipo de Entidad</span>
									<span class="info-value">{{ expedienteData.contraparte.tipoEntidad }}</span>
								</div>
								<div class="info-field">
									<span class="info-label">Razón Social</span>
									<span class="info-value">{{ expedienteData.contraparte.razonSocial }}</span>
								</div>
								<div class="info-field">
									<span class="info-label">Representante Legal</span>
									<span class="info-value">{{ expedienteData.contraparte.representanteLegal }}</span>
								</div>
								<div class="info-field">
									<span class="info-label">RFC</span>
									<span class="info-value">{{ expedienteData.contraparte.rfc }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Archivos -->
				<div class="case-block case-block-files mb-4">
					<div class="d-flex align-items-center justify-content-between mb-3">
						<h4 class="case-block-title case-block-title-blue mb-0">
							<i class="fa-regular fa-file-lines mr-2"></i>
							Archivos del Expediente
						</h4>
						<b-button
							size="sm"
							variant="outline-primary"
							@click="editingFiles = editingFiles === 1 ? null : 1"
						>
							{{ editingFiles === 1 ? 'Cancelar' : 'Agregar archivo' }}
						</b-button>
					</div>

					<div v-if="editingFiles === 1" class="file-upload-box mb-3">
						<div class="d-flex">
							<b-form-file
								v-model="uploadFile"
								class="flex-grow-1 mr-2"
								placeholder="Selecciona un archivo..."
								browse-text="Elegir"
							></b-form-file>
							<b-button variant="info" @click="handleAddFile(1)">Subir</b-button>
						</div>
					</div>

					<div class="row">
						<div
							v-for="(archivo, index) in caseFiles[1]"
							:key="'c1-' + index"
							class="col-md-6 mb-3"
						>
							<div class="file-item">
								<div class="d-flex align-items-center">
									<div class="file-icon">
										<i class="fa-regular fa-file-lines"></i>
									</div>
									<div>
										<p class="file-name mb-0">{{ archivo.name || archivo.nombre }}</p>
										<p class="file-meta mb-0">
											{{ archivo.tipo || 'PDF' }} · {{ archivo.date || archivo.fecha }}
										</p>
									</div>
								</div>
								<div class="file-actions">
									<button type="button" class="btn-icon" title="Ver">
										<i class="fa-regular fa-eye"></i>
									</button>
									<button type="button" class="btn-icon" title="Descargar">
										<i class="fa-regular fa-download"></i>
									</button>
									<button
										type="button"
										class="btn-icon"
										title="Eliminar"
										@click="handleRemoveFile(1, archivo.name || archivo.nombre)"
									>
										<i class="fa-regular fa-xmark"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Conversación Lexi -->
				<div class="case-block case-block-chat">
					<div class="d-flex align-items-center justify-content-between mb-3">
						<h4 class="case-block-title case-block-title-orange mb-0">
							<i class="fa-regular fa-comments mr-2"></i>
							Conversación con Lexi
						</h4>
						<b-button
							size="sm"
							variant="outline-warning"
							@click="showConversationModal = true"
						>
							Ver conversación completa
						</b-button>
					</div>
					<div class="last-message-panel">
						<div class="d-flex align-items-start">
							<div class="chat-mini-avatar">
								<i class="fa-regular fa-robot"></i>
							</div>
							<div>
								<p class="last-message-label mb-2">
									Último mensaje de Lexi
									<span class="text-muted">(20/01/2025)</span>
								</p>
								<p class="mb-0 small">{{ lastLexiMessage }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Caso 2 -->
		<div
			class="case-card mb-3"
			:class="{ expanded: expandedCase === 2 }"
			@click="toggleCase(2)"
		>
			<div class="case-card-header d-flex align-items-center justify-content-between">
				<div>
					<h3 class="case-title mb-1">Revisión de contrato</h3>
					<p class="case-desc mb-0">Derecho Laboral - 10 Enero 2025</p>
				</div>
				<div class="d-flex align-items-center">
					<span class="status-badge status-done">Completo</span>
					<i
						class="fa-regular ml-3 case-chevron"
						:class="expandedCase === 2 ? 'fa-chevron-down' : 'fa-chevron-right'"
					></i>
				</div>
			</div>

			<div v-if="expandedCase === 2" class="case-card-body" @click.stop>
				<div class="case-block case-block-files mb-4">
					<div class="d-flex align-items-center justify-content-between mb-3">
						<h4 class="case-block-title case-block-title-blue mb-0">
							<i class="fa-regular fa-file-lines mr-2"></i>
							Archivos del Expediente
						</h4>
						<b-button
							size="sm"
							variant="outline-primary"
							@click="editingFiles = editingFiles === 2 ? null : 2"
						>
							{{ editingFiles === 2 ? 'Cancelar' : 'Agregar archivo' }}
						</b-button>
					</div>

					<div v-if="editingFiles === 2" class="file-upload-box mb-3">
						<div class="d-flex">
							<b-form-file
								v-model="uploadFile"
								class="flex-grow-1 mr-2"
								placeholder="Selecciona un archivo..."
								browse-text="Elegir"
							></b-form-file>
							<b-button variant="info" @click="handleAddFile(2)">Subir</b-button>
						</div>
					</div>

					<div class="row">
						<div
							v-for="(archivo, index) in caseFiles[2]"
							:key="'c2-' + index"
							class="col-md-6 mb-3"
						>
							<div class="file-item">
								<div class="d-flex align-items-center">
									<div class="file-icon">
										<i class="fa-regular fa-file-lines"></i>
									</div>
									<div>
										<p class="file-name mb-0">{{ archivo.name }}</p>
										<p class="file-meta mb-0">PDF · {{ archivo.date }}</p>
									</div>
								</div>
								<div class="file-actions">
									<button type="button" class="btn-icon" title="Ver">
										<i class="fa-regular fa-eye"></i>
									</button>
									<button type="button" class="btn-icon" title="Descargar">
										<i class="fa-regular fa-download"></i>
									</button>
									<button
										type="button"
										class="btn-icon"
										title="Eliminar"
										@click="handleRemoveFile(2, archivo.name)"
									>
										<i class="fa-regular fa-xmark"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="case-block case-block-chat">
					<div class="d-flex align-items-center justify-content-between mb-3">
						<h4 class="case-block-title case-block-title-orange mb-0">
							<i class="fa-regular fa-comments mr-2"></i>
							Conversación con Lexi
						</h4>
						<b-button
							size="sm"
							variant="outline-warning"
							@click="showConversationModal = true"
						>
							Ver conversación completa
						</b-button>
					</div>
					<div class="last-message-panel">
						<div class="d-flex align-items-start">
							<div class="chat-mini-avatar">
								<i class="fa-regular fa-robot"></i>
							</div>
							<div>
								<p class="last-message-label mb-2">
									Último mensaje de Lexi
									<span class="text-muted">(10/01/2025)</span>
								</p>
								<p class="mb-0 small">
									Se completó la revisión de tu contrato laboral. Por favor, revisa los archivos adjuntos.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Caso 3 -->
		<div
			class="case-card mb-3"
			:class="{ expanded: expandedCase === 3 }"
			@click="toggleCase(3)"
		>
			<div class="case-card-header d-flex align-items-center justify-content-between">
				<div>
					<h3 class="case-title mb-1">Asesoría empresarial</h3>
					<p class="case-desc mb-0">Derecho Mercantil - 5 Enero 2025</p>
				</div>
				<div class="d-flex align-items-center">
					<span class="status-badge status-done">Completo</span>
					<i
						class="fa-regular ml-3 case-chevron"
						:class="expandedCase === 3 ? 'fa-chevron-down' : 'fa-chevron-right'"
					></i>
				</div>
			</div>

			<div v-if="expandedCase === 3" class="case-card-body" @click.stop>
				<p class="text-muted small mb-3">
					Asesoría completa sobre constitución de sociedad mercantil.
				</p>
				<b-button
					size="sm"
					variant="outline-secondary"
					@click="showConversationModal = true"
				>
					<i class="fa-regular fa-comments mr-2"></i>
					Ver conversación
				</b-button>
			</div>
		</div>

		<!-- Modal conversación -->
		<b-modal
			v-model="showConversationModal"
			title="Conversación con Lexi - Caso Laboral"
			size="lg"
			hide-footer
			scrollable
			modal-class="account-modal"
		>
			<div
				v-for="(msg, index) in expedienteData.conversacionLexi"
				:key="index"
				class="d-flex mb-3"
				:class="msg.sender === 'user' ? 'justify-content-end' : 'justify-content-start'"
			>
				<div
					class="chat-bubble"
					:class="msg.sender === 'user' ? 'chat-bubble-user' : 'chat-bubble-bot'"
				>
					<p class="mb-0 small">{{ msg.text }}</p>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
export default {
	name: 'MyAccountExpediente',

	data() {
		return {
			expandedCase: null,
			showConversationModal: false,
			editingFiles: null,
			uploadFile: null,
			caseFiles: {
				1: [
					{ name: 'INE.pdf', tipo: 'PDF', date: '20/01/2025' },
					{ name: 'Cedula_Fiscal.pdf', tipo: 'PDF', date: '20/01/2025' },
					{ name: 'Contrato_Laboral.pdf', tipo: 'PDF', date: '20/01/2025' },
					{ name: 'Correos_Evidencia.pdf', tipo: 'PDF', date: '21/01/2025' },
				],
				2: [
					{ name: 'Contrato_trabajo.pdf', date: '10 Ene 2025' },
					{ name: 'Recibos_nomina.pdf', date: '10 Ene 2025' },
				],
			},
			expedienteData: {
				tipoEntidad: 'Persona Física',
				nombreCompleto: 'Juan Carlos Pérez Martínez',
				rfc: 'PEMJ850315ABC',
				comentarios: 'Necesito asesoría sobre un contrato laboral que no se ha cumplido correctamente.',
				contraparte: {
					tipoEntidad: 'Persona Moral',
					razonSocial: 'Corporativo XYZ S.A. de C.V.',
					representanteLegal: 'María Fernanda López García',
					rfc: 'CXY201012XYZ',
				},
				conversacionLexi: [
					{ sender: 'lexi', text: '¡Hola! Soy Lexi, tu asistente legal. ¿En qué puedo ayudarte hoy?' },
					{ sender: 'user', text: 'Necesito ayuda con un problema laboral' },
					{
						sender: 'lexi',
						text: 'Entiendo tu consulta. Déjame buscar la mejor información para ayudarte.',
					},
					{ sender: 'user', text: 'Sí, por favor' },
					{
						sender: 'lexi',
						text: 'Perfecto. Primero necesito que completes tu expediente digital para que los abogados puedan ayudarte mejor.',
					},
				],
			},
		}
	},

	computed: {
		lastLexiMessage() {
			const list = this.expedienteData.conversacionLexi
			return list[list.length - 1].text
		},
	},

	methods: {
		toggleCase(id) {
			this.expandedCase = this.expandedCase === id ? null : id
		},

		handleAddFile(caseId) {
			if (this.uploadFile) {
				const files = this.caseFiles[caseId] ? [...this.caseFiles[caseId]] : []
				files.push({
					name: this.uploadFile.name,
					tipo: 'PDF',
					date: new Date().toLocaleDateString('es-MX'),
				})
				this.$set(this.caseFiles, caseId, files)
			}
			this.uploadFile = null
			this.editingFiles = null
		},

		handleRemoveFile(caseId, fileName) {
			const files = (this.caseFiles[caseId] || []).filter((f) => f.name !== fileName)
			this.$set(this.caseFiles, caseId, files)
		},
	},
}
</script>
